import type { AnimationEffectProps } from "./types";
import useScrollAnimation from "./scrollNavigation";
import useTapAnimation from "./tapNavigation";

function useAnimation({
    direction,
    elRef,
    filter,
    isInAuthor,
    isInLandscape,
    isInPlayWrightTest,
    isOverflowing,
    isPreviewer,
    navigationType,
    numberOfPages,
    onePercent,
    pageIndex,
    position,
    tapIdContainers,
    scrollerRef
}: AnimationEffectProps) {
    const pageTimeline: gsap.core.Timeline | undefined = useScrollAnimation({
        direction,
        elRef,
        filter,
        isInAuthor,
        isInLandscape,
        isInPlayWrightTest,
        isOverflowing,
        isPreviewer,
        navigationType,
        numberOfPages,
        onePercent,
        pageIndex,
        position,
        tapIdContainers,
        scrollerRef
    });
    useTapAnimation({
        direction,
        elRef,
        isInAuthor,
        isInPlayWrightTest,
        isOverflowing,
        isPreviewer,
        navigationType,
        numberOfPages,
        pageIndex,
        position,
    })
    return pageTimeline;
}

export default useAnimation